// extracted by mini-css-extract-plugin
export const main = "style-module--main--1Zw_q";
export const main__content = "style-module--main__content--2cpA5";